<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Changer la date de résiliation</div>
</div>

@if (dateLoadError) {
    <div class="text-center pt-3 error-message">
        Oups... Cette action n'est pas disponible actuellement Nous vous invitons à ré-essayer plus tard.
        <div class="w-100 pt-3 text-center proc-buttons">
            <div class="cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            </div>
        </div>
    </div>
}
@if (!dateLoadError && endBillingDateGroup) {
    <form [formGroup]="endBillingDateGroup" (ngSubmit)="confirmation()">
        <div class="col-12">
            <div class="form-group">
                <span class="bold-label-text float-left">Saisie de la nouvelle date de résiliation *</span>
                <mat-form-field>
                    @if (endBillingDateGroup.untouched || showPlaceHolder) {
                        <p class="datepicker-placeholder label">
                            JJ/MM/AAAA</p>
                    }
                    <input matInput (keyup)="showPlaceHolder = false" (dateChange)="setFinalBillingDate($event.value)"
                           formControlName="endBillingDateControl" [matDatepickerFilter]="dateRangeFilter"
                           [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon (click)="showPlaceHolder = false" id="calendar-icon" svgIcon="agenda"
                                  matDatepickerToggleIcon></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            @if (endBillingDateGroup.touched && invalidDatePicked) {
                <small class="error-message">
                    La date choisie est invalide.
                </small>
            }
            <div class="w-100 pt-3 text-center proc-buttons">
                <div class="cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button style="outline: none !important;" class="cta_btn level_2 column"
                            type="submit">Valider<span></span>
                    </button>
                </div>
            </div>
        </div>
    </form>
}
